import {
  WEBSITE_SIGNAL_TRIGGERS,
  MARKET_SIGNAL_TRIGGERS,
  LINKEDIN_SIGNAL_TRIGGERS,
  type SignalType,
} from '@/types/signals';

export type SignalFilterType = SignalType;

export interface SignalFilterConfig {
  type: SignalFilterType;
  triggerField: string;
  countField: string;
  capturedField: string;
  triggers: readonly string[];
  countLabelKey: string;
  triggerLabelKey: string;
  capturedLabelKey: string;
  categoryLabelKey: string;
}

export const SIGNAL_FILTER_CONFIGS: Record<SignalFilterType, SignalFilterConfig> = {
  website: {
    type: 'website',
    triggerField: 'trigger',
    countField: 'website_signal_count',
    capturedField: 'signal_at',
    triggers: WEBSITE_SIGNAL_TRIGGERS,
    countLabelKey: 'websiteSignalCount',
    triggerLabelKey: 'websiteSignalTrigger',
    capturedLabelKey: 'websiteSignalCapturedAt',
    categoryLabelKey: 'websiteSignal',
  },
  market: {
    type: 'market',
    triggerField: 'market_trigger',
    countField: 'market_signal_count',
    capturedField: 'market_signal_captured',
    triggers: MARKET_SIGNAL_TRIGGERS,
    countLabelKey: 'marketSignalCount',
    triggerLabelKey: 'marketSignalTrigger',
    capturedLabelKey: 'marketSignalCapturedAt',
    categoryLabelKey: 'marketSignal',
  },
  linkedin: {
    type: 'linkedin',
    triggerField: 'linkedin_trigger',
    countField: 'linkedin_signal_count',
    capturedField: 'linkedin_signal_captured',
    triggers: LINKEDIN_SIGNAL_TRIGGERS,
    countLabelKey: 'linkedinSignalCount',
    triggerLabelKey: 'linkedinSignalTrigger',
    capturedLabelKey: 'linkedinSignalCapturedAt',
    categoryLabelKey: 'linkedinSignal',
  },
};

export const SIGNAL_ACTION_TRANSLATION_KEYS: Record<string, string> = {
  visited_page: 'actions.visited_page',
  filled_form: 'actions.filled_form',
  abandoned_form: 'actions.abandoned_form',
  researched_topic: 'actions.researched_topic',
  explored_product: 'actions.explored_product',
  evaluated_competitor: 'actions.evaluated_competitor',
  followed_page: 'linkedinSignalItem.actions.followed_page',
  followed_competitor: 'linkedinSignalItem.actions.followed_competitor',
  commented_post: 'linkedinSignalItem.actions.commented_post',
  reacted_post: 'linkedinSignalItem.actions.reacted_post',
  authored_post: 'linkedinSignalItem.actions.authored_post',
  connected: 'actions.connected',
  opened: 'actions.opened',
  received: 'actions.received',
  evaluated: 'actions.evaluated',
};
